<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div class="form-group row">
            <label for="" class="col-lg-2 font-weight-bold">Branch</label>
            <div class="col-lg-6">
              <select name="tahun" id="branch" class="custom-select" v-model="branch">
                <option value="0">All</option>
                <template v-for="bran in branchs">
                  <option v-bind:value="bran.id.toString()" :key="bran.id">{{bran.name}}</option>
                </template>
              </select>
            </div>
          </div>
          <div class="form-group row">
            <label for="" class="col-lg-2 font-weight-bold">Periode</label>
            <div class="col-lg-6">
              <date-picker v-model="month" lang="en" format="MMMM YYYY" type="month"></date-picker>
            </div>

          </div>
          <div class="form-group row">
            <button class="btn btn-primary" @click="submit">Submit</button>
          </div>
          <br>

              <b-tabs fill content-class="mt-3" v-if="dataInsentif.length > 0">

                <b-tab title="Insentif ">
                  <span> Periode : {{periode.start}} sampai {{periode.end}}</span> &nbsp;&nbsp;
                  <button class="btn btn-primary" @click="showSummary">{{nameButton}}</button>&nbsp;
                  <button class="btn btn-secondary" :disabled="!visiblePrint" @click="goTo">Print</button>

                    <b-row>
                    <div class="table-responsive"  id="parent">
                      <template v-if="shiw">
                        <arrow :body="'body-insentif'" />
                      </template>
                      <div class="loadingEvent" v-if="loadingSummary">
                        <pulse-loader :size="'12px'"></pulse-loader>
                      </div>
                      <table class="table table-bordered treand" id="table-presence">

                        <thead id="head-insentif">
                        <tr
                          name="add-column"
                          is="transition-group"
                          @enter="enter"
                          @after-enter="afterEnter"
                          @before-leave="beforeLeave"
                          @leave="leave"
                        >
                          <th  id="name-list" :key="'th-1'"></th>
                          <template v-if="shiw">
                          <th  :colspan="monthSelect | sumDay" :key="'th-2'">
                            <div>{{monthSelect | nameMonth(false)}}</div></th>
                          <th colspan="25" :key="'th-3'"><div>{{monthSelect | nameMonth(true)}}</div></th>
                          </template>
                          <th :rowspan="2" style="min-width: 80px" :key="'th-4'">Insentif</th>
                        </tr>
                        <tr
                          name="add-column"
                          is="transition-group"
                          @enter="enter"
                          @after-enter="afterEnter"
                          @before-leave="beforeLeave"
                          @leave="leave"
                        >
                          <th :key="'th-5'"><strong>Name</strong></th>
                          <template v-if="shiw">
                          <template v-for="(date, n) in dataInsentif">
                            <th :key="'thn-' + n" style="min-width: 70px; text-align: center" v-bind:class="date.working_day == false ? 'holiday': ''">
                              <div>{{date.date | changePosition}}</div></th>
                          </template>
                          </template>
                        </tr>
                        </thead>
                        <tbody id="body-insentif" v-on:scroll="fixscroll()">
                        <template v-for="(name,indeks) in summary">
                          <tr>
                            <td class="fix-content" ref="column" :key="'name' + indeks">{{name.name}}</td>
                            <template v-if="shiw">
                            <template v-for="(date, i) in dataInsentif" >
                              <td
                                align="center"
                                v-bind:class="date.working_day == false ? 'holiday': ''"
                                v-bind:style="{ 'background-color': checkcolor (date.presence, name.user_id), 'min-width': 70 + 'px' }"
                                :key="'day' + indeks + '-' + i"
                              >
                                <template v-for="position in check(date.presence, name.user_id)">

                                  <i v-bind:class="position.presence_status == 'Hadir' ? 'fa fa-check-circle text-success' : position.presence_status == 'Terlambat' ? 'fa fa-check-circle text-danger' : position.presence_status == 'Cuti' ? 'fa fa-exclamation-circle text-warning' : position.presence_status ? 'fa fa-times-circle text-danger' : ''"
                                     v-b-tooltip.hover
                                     v-bind:title="position.presence_status + ' : ' + timeIn(position.time_in) + '\n' + 'Deadline time : ' + position.time_deadline"
                                  ></i>
                                </template>
                              </td>
                            </template>
                            </template>
                            <!--<td v-bind:class="summary[indeks].editable ? 'presence-hover' : ''"-->
                            <!--v-bind:title="summary[indeks].editable ? 'edit': ''"-->
                            <!--@click="goModal(summary[indeks], indeks)"-->
                            <!--&gt;-->
                            <td class="presence-hover editNow"
                                v-b-tooltip.hover
                                @click="goModal(summary[indeks], indeks)"
                                style="min-width: 80px"
                                :key="'total-'+ indeks"
                                :id="'total' + indeks"
                            >
                              <template v-if="summary[indeks].incentive">
                                {{summary[indeks].incentive_value}}
                                <br>
                                {{summary[indeks].incentive_note}}
                              </template>
                              <span class="subscript" >
                                <i class="fa fa-pencil text-info"></i>
                              </span>
                            </td>
                            <b-tooltip :target="'total' + indeks">
                              <template v-if="summary[indeks].update_by">
                               edit by {{summary[indeks].update_by}}
                              </template>
                              <template v-else>
                                edit
                              </template>
                            </b-tooltip>
                          </tr>
                        </template>

                        </tbody>
                      </table>
                      <strong v-if="summary.length > 0">
                        Total Insentive this month : Rp {{summary | totalInsentif}}
                      </strong>
                      <br>
                    </div>
                    </b-row>
                  <template v-if="shiw">
                    <strong>Keterangan</strong>
                    <br>
                    <span class="dot" style="background: #ffd833"></span> Pulang Lebih Cepat &nbsp;
                    <span class="dot" style="background: #8afda3"></span> Datang Lebih Cepat &nbsp;
                    <span class="dot" style="background: #f86c6b26"></span> Hari Libur &nbsp;
                    <br>
                    <i class="fa fa-check-circle text-success"></i> Datang Ke kantor &nbsp;
                    <i class="fa fa-check-circle text-danger"></i> Terlambat &nbsp;
                    <i class="fa fa-exclamation-circle text-warning"></i> Cuti &nbsp;
                    <i class="fa fa-times-circle text-danger"></i>  Sakit / Izin&nbsp;
                  </template>
                  <div id="printMe" v-if="summary.length > 0" v-show="false">
                    <laporan-insentif :summary="summary" :start="periode.start" :end="periode.end"/>
                  </div>
                </b-tab>
                <!--Laporan Insentif-->
                <!--<b-tab title="Laporan Insentif">-->
                 <!--<table class="table table-bordered">-->
                   <!--<thead>-->
                     <!--<tr>-->
                       <!--<th>Name</th>-->
                       <!--<th>Presence</th>-->
                       <!--<th>Pasang baru</th>-->
                       <!--<th>Survey Pasang</th>-->
                       <!--<th>Survey</th>-->
                       <!--<th>TTS Open</th>-->
                       <!--<th>TTS Close</th>-->
                       <!--<th>Sprint</th>-->
                       <!--<th>Total</th>-->
                     <!--</tr>-->
                   <!--</thead>-->
                   <!--<tbody>-->
                      <!--<template v-for="(data, i) in dataLaporan">-->
                        <!--<tr>-->
                          <!--<td>{{data.name}}</td>-->
                          <!--<td>{{data.insentif_presence}}</td>-->
                          <!--<td>{{data.pasbar | show(data.value_pasbar)}}</td>-->
                          <!--<td>{{data.survey | show(data.value_survey_pasang)}}</td>-->
                          <!--<td>{{data.total_survey | show(data.value_survey)}}</td>-->
                          <!--<td>{{data.tts_open  | show(data.value_tts_open)}}</td>-->
                          <!--<td>{{data.tts_close | show(data.value_tts_close)}}</td>-->
                          <!--<td>{{data.sprint}}</td>-->
                          <!--<td>{{data | total}}</td>-->
                        <!--</tr>-->
                      <!--</template>-->
                      <!--<template>-->
                        <!--<tr>-->
                          <!--<td align="center"><strong>Total</strong></td>-->
                          <!--<td> {{totalbyType(dataLaporan, 'presence') | pointmoney}}</td>-->
                          <!--<td>{{totalbyType(dataLaporan, 'pasbar') | pointmoney}}</td>-->
                          <!--<td>{{totalbyType(dataLaporan, 'survey') | pointmoney}}</td>-->
                          <!--<td> {{totalbyType(dataLaporan, 'total_survey') | pointmoney}}</td>-->
                          <!--<td>{{totalbyType(dataLaporan, 'tts_open') | pointmoney}}</td>-->
                          <!--<td>{{totalbyType(dataLaporan, 'tts_close') | pointmoney}}</td>-->
                          <!--<td>{{totalbyType(dataLaporan, 'sprint') | pointmoney}}</td>-->
                          <!--<td>{{totalAll(dataLaporan) | pointmoney}}</td>-->
                        <!--</tr>-->
                      <!--</template>-->
                   <!--</tbody>-->
                 <!--</table>-->
                <!--</b-tab>-->
              </b-tabs>

        </b-card>
      </b-col>
    </b-row>

    <b-modal title="Edit Laporan" class="modal-info" v-model="infoModal" @ok="infoModal = false;submitInsentive()" ok-variant="info">
      <b-form-group
        description=""
        label="User Id"
        label-for="userId"
        :label-cols="3"
        :horizontal="true">
        <b-form-input id="userId" :disabled="true" type="text" :value="editInsentif.user_id" v-model="editInsentif.user_id"></b-form-input>
      </b-form-group>
      <b-form-group
        description=""
        label="Nama"
        label-for="basicName"
        :label-cols="3"
        :horizontal="true">
        <b-form-input id="basicName" :disabled="true" type="text" :value="editInsentif.name" v-model="editInsentif.name"></b-form-input>
      </b-form-group>
      <b-form-group
        description=""
        label="Insentive"
        label-for="insentive"
        :label-cols="3"
        :horizontal="true">
        <b-form-input id="insentive"  type="number" :value="editInsentif.incentive_value" v-model="editInsentif.incentive_value"></b-form-input>
      </b-form-group>
      <b-form-group
        description=""
        label="Note"
        label-for="note"
        :label-cols="3"
        :horizontal="true">
        <b-form-input id="note"  type="text" :value="editInsentif.incentive_note" v-model="editInsentif.incentive_note"></b-form-input>
      </b-form-group>
      <span class="hover-text" v-if="editLogInsentif.length > 0" @click="showLog = !showLog">Show Log</span>
      <template v-if="showLog">
        <table class="table table-bordered">
          <thead>
          <tr>
            <th>No</th>
            <th>Edit by</th>
            <th>Value</th>
            <th>Note</th>
          </tr>
          </thead>
          <tbody>
            <template v-for="(edit, i) in editLogInsentif">
              <tr>
                <td>{{i + 1}}</td>
                <td>{{edit.update_by}}</td>
                <td>{{edit.incentive_value}}</td>
                <td>{{edit.incentive_note}}
                  <br><strong>in </strong>{{edit.updated_at}}
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </template>
    </b-modal>
  </div>

</template>
<script>
  import { getService } from "../../services";
  import { postService} from "../../services";
  import DatePicker from 'vue2-datepicker'
  import Arrow from '../../component/Arrow'
  import moment from 'moment'
  import LaporanInsentif from '../print/LaporanInsentif'
  import Vue from 'vue'
  import VueHtmlToPaper from 'vue-html-to-paper';
  import PulseLoader from 'vue-spinner/src/PulseLoader'


  const options = {
    name: '_blank',
    specs: [
      'fullscreen=yes',
      'titlebar=yes',
      'scrollbars=yes',
    ],
    styles: [
        '@/assets/scss/style.scss',
      'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
      'https://unpkg.com/kidlat-css/css/kidlat.css'
    ]
  }

  Vue.use(VueHtmlToPaper, options);


  export default {
    components: {
      DatePicker,
      Arrow,
      LaporanInsentif,
      PulseLoader
    },
    data() {
      return {
        shiw: false,
        loadingSummary: false,
        nameButton: 'Detail',
        branch: '',
        branchs: [],
        infoModal: false,
        month: moment(),
        monthSelect: '',
        checkBranch: '',
        visiblePrint: false,
        showLog: false,
        editLogInsentif: [],
        periode: {
          start: moment().subtract(1,'month').format('26 MMMM YYYY'),
          end: moment().format('25 MMMM YYYY')
        },
        dataInsentif: [],
        summary: [],
        dataLaporan: [],
        // totalInsentif: 0,
        indeksEditInsentif: 0,
        editInsentif: {
          user_id: '',
          name: '',
          incentive: false,
          incentive_value: '',
          incentive_note: '',
          editable: true
        }
      }
    },
      created: function () {
      // this.getJson(); Laporan Insentif
      this.getBranch()
      var that = this
      if(this.$store.getters.monthInsentif) {
        this.month = this.$store.getters.monthInsentif
        this.monthSelect = this.month
        this.periode.start = moment(this.month).subtract(1,'month').format('26 MMMM YYYY'),
        this.periode.end = moment(this.month).format('25 MMMM YYYY')
      }
      if (this.$store.getters.branchInsentif) {
        this.branch = this.$store.getters.branchInsentif
      }else if (this.$store.getters.branchInVendor) {
        this.branch = this.$store.getters.branchInVendor
      } else {
        this.checkBranch = setInterval(() => {
          that.branch = that.$store.getters.branch
          if (that.branch) {
            clearInterval(that.checkBranch)
          }
        }, 1000);
      }
      if (this.$store.getters.summaryInsentif.length > 0) {
        this.visiblePrint = true
        this.summary = this.$store.getters.summaryInsentif
        this.dataInsentif = this.$store.getters.dataInsentif
      }
    },
    watch: {
      monthSelect: {
        handler: function(val) {
          this.periode.start = moment(val).subtract(1,'month').format('26 MMMM YYYY'),
            this.periode.end = moment(val).format('25 MMMM YYYY')
        }
      }
    },
    methods: {
      getJson() {
        getService.getJSON()
          .then( data => {
            // console.log(data)
            let a = []
            for (let i in data.summary) {
              a.push(data.summary[i])
              // console.log(data.summary[i])
            }
            this.dataLaporan = a
          })
      },
      async getBranch() {
        try {
          await getService.list_branch()
            .then(data => {
              this.branchs = data
            })
        } catch (error) {
          // bila data tidak terpanggil
        }
      },
      async getListInsentif(branch, year, periode) {
        try {
          this.$store.commit('noLoad', true)
          await getService.list_insentif(branch, year, periode)
            .then(data => {
              this.$store.commit('noLoad', false)
              let total = 0
              this.dataInsentif = data.data
              let summary = []
              for(let i in data.summary) {
                summary.push(data.summary[i])
                // if(data.summary[i].incentive) {
                //   total += data.summary[i].incentive_value
                // }
              }
              // this.totalInsentif = total
              this.summary = summary
              this.visiblePrint = true
              this.$store.commit('changeInsentifSummary', summary)
              this.$store.commit('changeDetailInsentif', data.data)
              setTimeout( () => {
                // console.log(this.$refs.column[0].offsetWidth + 'px')
                document.getElementById('name-list').style.width  = this.$refs.column[0].offsetWidth + 'px'
              }, 1000)

            })
        } catch (error) {

        }
      },
      submit() {
        this.monthSelect = this.month
        this.$store.commit('changeMonthInsentif', this.month)
        this.$store.commit('changeBranchInsentif', this.branch)
        const year = moment(this.month).format('YYYY')
        const month = moment(this.month).format('MM')
        this.getListInsentif(this.branch, year, month)
      },
      check(presence, user_id) {
        let data = []
        for (let i = 0; i < presence.length; i++){
         if (presence[i].user_id == user_id) {
           const a = {
             presence_status: presence[i].presence_status,
             time_deadline: presence[i].time_deadline,
             time_in: presence[i].time_in
           }
           data.push(a)
         }
        }
        return data
      },
      checkcolor(presence, user_id) {
        for (let i = 0; i < presence.length; i++){
          if (presence[i].user_id == user_id) {
             if (presence[i].home_early ) {
               return '#ffd833'
             }
             if (presence[i].presence_early && presence[i].presence_early != '-') {
               return '#8afda3'
             } else {
               return null
             }
          }
        }

      },
      goModal(data, i) {
        // if(data.editable) {
          this.infoModal = true
          this.indeksEditInsentif = i
          this.editInsentif.name = data.name
          this.editInsentif.incentive = data.incentive
          this.editInsentif.user_id = data.user_id
          this.editInsentif.incentive_value = data.incentive_value
          this.editInsentif.incentive_note = data.incentive_note
          this.showLog = false
          this.editLogInsentif = []
          if (data.update_by_id) {
              const detail = {
                  update_by: data.update_by,
                  incentive_value: data.incentive_value,
                  incentive_note: data.incentive_note,
                  updated_at: data.updated_at,
              }
              this.editLogInsentif = data.update_log || []
              this.editLogInsentif.unshift(detail)
          }

        // }
      },
      submitInsentive() {
        this.editInsentif.incentive = 1
        this.monthSelect = this.month
        const year = moment(this.month).format('YYYY')
        const month = moment(this.month).format('MM')
        postService.post_edit_insentif(this.editInsentif.user_id, year, month, this.editInsentif.incentive_value, this.editInsentif.incentive_note)
          .then(data=> {
            Vue.set(this.summary, this.indeksEditInsentif, this.editInsentif)
          })
      },
      fixscroll() {
        const thead = document.getElementById("head-insentif");
        const tbodyScroll = document.getElementById("body-insentif").scrollLeft;
        thead.scrollLeft = tbodyScroll;
        //document.getElementById("frozen").scrollLeft = 0;
      },
      timeIn(time) {
        if (time && time !== '-') {
          return moment(time, 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss')
        }
        return '-'
      },
      totalAll(data) {
        let totalInsentif = 0
        for (let i in data) {
          totalInsentif +=  Number(data[i].insentif_presence)
          data[i].pasbar ? totalInsentif +=  Number(data[i].pasbar) * data[i].value_pasbar : false
          data[i].survey ? totalInsentif += Number(data[i].survey) * data[i].value_survey_pasang : false
          data[i].total_survey ? totalInsentif += Number(data[i].total_survey) * data[i].value_survey_pasang : false
          data[i].tts_close ? totalInsentif += Number(data[i].tts_close) * data[i].value_tts_close : false
          data[i].tts_open ? totalInsentif += Number(data[i].tts_open) * data[i].value_tts_open : false
          totalInsentif += Number(data[i].sprint)
        }
        return totalInsentif
      },
      totalbyType(data, type) {
        let total = 0
        for (let i in data) {
          switch (type) {
            case 'presence':
              total += Number(data[i].insentif_presence)
              break
            case 'pasbar':
              data[i].pasbar ? total +=  Number(data[i].pasbar) * data[i].value_pasbar : false
              break
            case 'survey':
              data[i].survey ? total += Number(data[i].survey) * data[i].value_survey_pasang : false
              break
            case 'total_survey':
              data[i].total_survey ? total += Number(data[i].total_survey) * data[i].value_survey_pasang : false
              break
            case 'tts_open':
              data[i].tts_open ? total += Number(data[i].tts_open) * data[i].value_tts_open : false
              break
            case 'tts_close':
              data[i].tts_close ? total += Number(data[i].tts_close) * data[i].value_tts_close : false
              break
            case 'sprint':
              total += Number(data[i].sprint)
              break
          }
        }
        return total
      },
      goTo() {
        // let routeData = this.$router.resolve({name: 'printInsentif'});
        // window.open(routeData.href, '_blank');
        this.$htmlToPaper('printMe')
      },
        enter (el) {
            const width = getComputedStyle(el.firstChild).width;
            el.firstChild.style.width = 0;
            setTimeout(() => {
                el.firstChild.style.width = width;
            });
        },
        afterEnter(el) {
            el.firstChild.style.width = 'auto';
            this.loadingSummary = false
        },
        beforeLeave (el) {
            el.firstChild.style.height = getComputedStyle(el.firstChild).height;
        },
        leave (el) {
            this.loadingSummary = false
            el.firstChild.style.width = getComputedStyle(el).width;
            setTimeout(() => {
                el.firstChild.style.width = 0;
            });
        },
        async showSummary() {
          this.loadingSummary = true

          if(this.shiw) {
              this.nameButton = 'Detail'
          } else {
             this.nameButton = 'Summary'
          }
          this.shiw = !this.shiw
        }
    },
    filters: {
      changePosition(time) {
        let fulltime = time.split('-', 3)
        return fulltime[2]
      },
      sumDay(month) {
        let day = moment(month).subtract('1', 'M').daysInMonth()
        return day - 25
      },
      nameMonth(month, last) {
        if (last) {
          return moment(month).format('MMMM')
        } else {
          return moment(month).subtract('1', 'M').format('MMMM')
        }
      },
      totalInsentif(data) {
        let total = 0
        for(let i =0; i < data.length ; i++) {
          if(data[i].incentive) {
            total += Number(data[i].incentive_value)
          }
        }
         return total.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
      },
      show(value, data) {
        if (value) {
          return value + ' X ' + data
        }
      },
      total(data) {
        let totalInsentif = 0
        totalInsentif +=  Number(data.insentif_presence)
        data.pasbar ? totalInsentif +=  Number(data.pasbar) * data.value_pasbar : false
        data.survey ? totalInsentif += Number(data.survey) * data.value_survey_pasang : false
        data.total_survey ? totalInsentif += Number(data.total_survey) * data.value_survey_pasang : false
        data.tts_close ? totalInsentif += Number(data.tts_close) * data.value_tts_close : false
        data.tts_open ? totalInsentif += Number(data.tts_open) * data.value_tts_open : false
        totalInsentif += Number(data.sprint)
        return totalInsentif
      }

    }
  }
</script>
<style scoped>
  td.holiday, th.holiday {
    background-color: #f86c6b26;
  }
  .fix-content{
    /*max-width:100%;*/
    /*white-space:nowrap;*/
    min-width: 269px;
  }
  .presence-hover:hover{
    border: blue 0.25em solid;
    cursor: pointer;
  }



  #parent {
    position: static;
    /*left: 10vw;*/
    /*top: 15vh;*/
    width: 98vw;
    height: 75vh;
    overflow: auto;
  }

  table.treand {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    width: 100%;
    height: 100%;
    /*border: 1px solid #ccc;*/
    border-collapse: collapse;
    overflow: hidden;
    /* Use this to create a "dead" area color if table is too wide for cells */
  }

  .treand>thead {
    /*
    Grow thead automatically to fit content, don't shrink it
    proportionately to the body.
    */
    flex: 1 0 auto;
    display: block;
    /* x-scrolling will be managed via JS */
    overflow-x: hidden;
    /*
    Keep header columns aligned with useless scrollbar.
    For IE11, use "dead area" color to hide scrollbar functions
    */
    /*overflow-y: scroll;*/
    scrollbar-base-color: #ccc;
    scrollbar-face-color: #ccc;
    scrollbar-highlight-color: #ccc;
    scrollbar-track-color: #ccc;
    scrollbar-arrow-color: #ccc;
    scrollbar-shadow-color: #ccc;
    scrollbar-dark-shadow-color: #ccc;
  }

  /*
  For Webkit, use "dead area" color to hide scrollbar functions
  TODO: on Chrome/Safari for Mac, scrollbars are not shown anyway and
  this creates an extra block. No impact on iOS Safari.
  */
  .treand>thead::-webkit-scrollbar { display: none;  }

  /* Scroll the actual tbody (second child on all browsers) */
  .treand>tbody {
    display: block;
    overflow: scroll;
  }

  /* IE11 adds an extra tbody, have to hide it */
  tbody:nth-child(3) { display: none; }

  /* The one caveat, a hard-set width is required. */


  table.treand>*>tr>td:first-child,
  th:first-child {

    position: sticky;
    position: -webkit-sticky;
    left:0;
    background: #f2f2f2;
  }

  #head-insentif>tr>th:first-child{
    min-width: 269px;
  }

  td.editNow{
    position:relative;
  }

  span.subscript{
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 2;
    text-align: right;
    vertical-align: bottom;
    font-size: 10px;
  }

  .add-column-enter-to, .add-column-leave {
    opacity: 1;
  }
  .add-column-enter, .add-column-leave-to {
    overflow: hidden;
    opacity: 0;
  }
  .add-column-enter-active > div {
    transition: all 1s;
  }
  .add-column-enter-active {
    overflow: hidden;
    transition: all 1s;
  }
  .add-column-leave-active {
    overflow: hidden;
    transition: all 1s;
  }
  .add-column-leave-active > div {
    transition: all 1s;
  }
  .add-column-leave-to > div {
    width: 0;
  }

  div.loadingEvent{
    display: block;
    position: absolute;
    z-index: 2;
    top: 60%;
    left: 30%;
  }

  .hover-text{
    cursor:pointer;
    color: #1e6abc;
  }
  .hover-text:hover{
    text-decoration: underline;
    color: #00aced;
  }

</style>
